import classNames from 'classnames';

import { Button } from '@/components/atoms/Button';
import type { Variant } from '@/components/atoms/Button/button.d';

type AIToggleButtonProps = {
	testId?: string;
	navOpen: boolean;
	mobileOnly?: boolean;
	onToggle?: () => void;
	navDarkVariant?: boolean;
};

const AIToggleButton = (props: AIToggleButtonProps) => {
	const {
		testId = 'AIToggleButton',
		mobileOnly = false,
		navOpen,
		navDarkVariant,
		onToggle,
	} = props;

	let buttonVariant: Variant | undefined = 'text';
	if (mobileOnly) {
		buttonVariant = navDarkVariant ? 'tiny-transparent' : 'tiny-subtle';
	}

	return (
		<Button
			data={{ testId }}
			variant={buttonVariant}
			onClick={onToggle}
			className={classNames('border-2', {
				'border-black': !mobileOnly && !navDarkVariant,
				'border-white': !mobileOnly && navDarkVariant,
				'xl:hidden': mobileOnly,
				'opacity-0': navOpen,
			})}
		>
			Ask AI
		</Button>
	);
};

export default AIToggleButton;
